import { BankDetailCreateModal } from "Company/Modules/BankDetail/Components/BankDetailCreateModal";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { AddCircle } from "@mui/icons-material";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { type FC, useState } from "react";

type Props = {
	companyId: number;
};

const bankDetailResources = Resources.base.bankDetail.shared;

export const BankDetailCreateCard: FC<Props> = ({ companyId }) => {
	const { t } = useResource();
	const [createModalOpen, setCreateModalOpen] = useState(false);
	return (
		<>
			<Stack
				border={1}
				padding={2}
				borderRadius={1}
				gap={3}
				alignItems="center"
				justifyContent="center"
				height="100%"
				onClick={() => setCreateModalOpen(true)}
				sx={{
					cursor: "pointer",
					borderColor: (theme) => theme.palette.divider,
					borderStyle: "dashed",
				}}
			>
				<Typography variant="h5">
					{t(bankDetailResources.addBankDetail)}
				</Typography>
				<Box>
					<AddCircle
						fontSize="large"
						sx={{ color: useTheme().palette.primary.main }}
					/>
				</Box>
			</Stack>
			{createModalOpen && (
				<BankDetailCreateModal
					isOpen={createModalOpen}
					setIsOpen={setCreateModalOpen}
					companyId={companyId}
				/>
			)}
		</>
	);
};
